import { render } from "./DataTableHistogram.vue?vue&type=template&id=e46a3824"
import script from "./DataTableHistogram.vue?vue&type=script&lang=js"
export * from "./DataTableHistogram.vue?vue&type=script&lang=js"

import "./DataTableHistogram.vue?vue&type=style&index=0&id=e46a3824&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__